export default class SharedModule {
  constructor(controller) {
    this.controller = controller;
  }

  initialize() {
    this.initSharedWeekScales();
    this.initSharedScale();
  }

  initSharedWeekScales() {
    $(".shared-week-scales").on("click", (event) => {
      const requestData = {
        start_at: $(event.currentTarget).data("start-at"),
        end_at: $(event.currentTarget).data("end-at"),
        ministry_id: $(event.currentTarget).data("ministry-id"),
      };
      this.sendWhatsAppShareRequest(requestData);
    });
  }

  initSharedScale() {
    $(".shared-scale").on("click", (event) => {
      const requestData = {
        scale_id: $(event.currentTarget).data("scale-id"),
      };
      this.sendWhatsAppShareRequest(requestData);
    });
  }

  sendWhatsAppShareRequest(requestData) {
    $.ajax({
      url: "/api/ministry_scales/whatsapp/shared",
      data: requestData,
      success: (response) => {
        const whatsappLink = `whatsapp://send?text=${response.message}`;
        window.location.href = whatsappLink;
      },
    });
  }
}
